function setFoods(data) {
	return {
		type: 'SET_FOODS',
		payload: data,
	};
}

export { setFoods };
